import React from "react"
import FieldTypes from "src/pages/dynamic_forms/Types/FieldTypes"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import SignatureCanvas from "react-signature-canvas"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import mobileFriendlyWarning from "src/pages/dynamic_forms/Utils/MobileFriendlyWarning/MobileFriendlyWarning"
import reoccuringText from "src/pages/dynamic_forms/Utils/ReoccuringText"
import "./SignatureField.css"
import "../../DynamicForm.css"
interface Props {
    manageParentState: Function
    handleChange: Function
    field: FieldTypes
    row: number
    col: number
    formManagerField?: boolean
    configField?: boolean
    templateField?: boolean
    remove: Function
    palette: Array<DynamicFormPaletteTypes>
    readOnly?: boolean
}

function SignatureField(props: Props | any) {

    // console.log("df_FieldSignatureField props", props)

    let signatureCanvas: any = null
    const field = props.field
    const name = field.Name || "Signature"
    const templateField = props.templateField
    const formManagerField = props.formManagerField
    const configField = props.configField
    const fieldType = templateField ? "TemplateField" : formManagerField ? "FormMangerField" : configField ? "ConfigField" : "Field"
    const imgeStr = field.Value ? (field.Value.indexOf("data:image/png;base64,") === -1 ? field.Value : field.Value.split("data:image/png;base64,")[1]) : null

    const handleSignature = (clear?: boolean) => {
        if (signatureCanvas && signatureCanvas.getTrimmedCanvas().width > 150) {
            if (clear) {
                signatureCanvas.clear()
            }
            const canvas = signatureCanvas.getTrimmedCanvas()
            props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Value" } }])
            const base64Img = canvas.toDataURL().split("data:image/png;base64,")[1]
            setTimeout(() => {
                props.handleChange({ target: { value: clear ? null : base64Img } })
            }, 125)
        } else {
            setTimeout(() => {
                handleSignature()
            }, 500)
        }
    }

    const SignatureFieldToolTip = (text: string) => (
        <Tooltip id="signtaure-field-tooltip">
            {text}
        </Tooltip>
    )

    return (
        <div className={`DynamicForm${fieldType} DynamicFormSignature${fieldType}`} style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldBackgroundColor")}` }}>
            <div className="DynamicFormFieldHeader">
                {!formManagerField && <div className="DynamicFormFieldHeaderLeft">
                    <p style={{ color: `${paletteEngine.getPaletteColor("headerTextColor")}` }}>{name}</p>
                    {field.Required && !field.Value && <span className="material-icons" style={{ color: `${paletteEngine.getPaletteColor("requiredFieldAsteriskColor")}` }}>*</span>}
                </div>}
                <div className="DynamicFormFieldHeaderRight">
                    {templateField && <div className="DynamicFormFieldHeaderRightSettings">
                        <div className="DynamicFormFieldHeaderRightSettingsMultiColumnarWarning">
                            {props.col > 0 &&
                                <OverlayTrigger placement="right" overlay={mobileFriendlyWarning("Rows with multiple columns", reoccuringText.multipleColumnInRowWarningText)}>
                                    <span
                                        className="material-icons"
                                        style={{ color: `${paletteEngine.getPaletteColor("editorConfigMultiColumnsWarningIconColor")}` }}>
                                        priority_high
                                    </span>
                                </OverlayTrigger>}
                        </div>
                        <span className="material-icons DynamicFormFieldHeaderRightSettingsGear"
                            style={{ color: `${paletteEngine.getPaletteColor("editorConfigGearColor")}` }}
                            onClick={() => props.manageParentState([{ key: "configTarget", value: { row: props.row, col: props.col } }])}>
                            settings
                        </span>
                        <TrashCan clickCallback={() => props.remove(field.Type, props.row, props.col, true)} color={`${paletteEngine.getPaletteColor("editorTrashBinColor")}`} />
                    </div>}
                </div>
            </div>
            <div className="DynamicFormFieldBody" style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}` }}>
                <div className="DynamicFormFieldBodySignatureBody" style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}` }}>
                    {!props.readOnly && <SignatureCanvas
                        ref={(ref) => { signatureCanvas = ref }}
                        canvasProps={{ className: "sigCanvas" }}
                        penColor={`${paletteEngine.getPaletteColor("signatureColor")}`}
                        onEnd={() => handleSignature()}
                        backgroundColor={"#00000000"}
                    />}
                </div>
                {imgeStr && props.readOnly && <img id="dynamic-form-signature-field-img" src={`data:image/png;base64,${imgeStr}`} alt="" />}
            </div>
            {!formManagerField && <div className="DynamicFormFieldBodySignatureFooter" >
                <div className="DynamicFormFieldBodySignatureFooterLeft">
                    {field.Value && !props.readOnly && <div className="DynamicFormFieldBodySignatureFooterControlsValid">
                        <OverlayTrigger placement="top" overlay={SignatureFieldToolTip("Clear")}>
                            <span className="material-icons" onClick={() => handleSignature(true)} style={{ color: `${paletteEngine.getPaletteColor("formXIconColor")}` }}>close</span>
                        </OverlayTrigger>
                    </div>}
                </div>
                <div className="DynamicFormFieldBodySignatureFooterRight">
                    {/*empty div*/}
                </div>
            </div>}
        </div>
    )
}

export default SignatureField